import React from 'react';
import { Layout } from 'antd';
import { ReactComponent as EuropeanUnionLogo } from 'assets/icons/EU-1024x317 1.svg';
import { ReactComponent as GreeceGovernmentLogo } from 'assets/icons/Government-logo2 1.svg';
import { ReactComponent as GreenMinistryLogo } from 'assets/icons/YPEN-logo.svg';
import { ReactComponent as Tayped } from 'assets/icons/ypen_logo.svg';
import { useLocation } from 'react-router-dom';

const { Content } = Layout;

const Footer = () => {
  return (
    <div className="footer-container">
    <div className="footer-background"></div>
    <div className="footer-content">
      <div className="footer-logo">
        <GreenMinistryLogo />
      </div>
      {/* <div className="footer-logo">
        <Tayped/>
      </div> */}
      <div className="footer-logo">
        <EuropeanUnionLogo />
      </div>
      <div className="footer-logo">
        <GreeceGovernmentLogo />
      </div>
    </div>
  </div>
  );
};

export default Footer;
